import { resolveComponent as _resolveComponent, createVNode as _createVNode, createElementVNode as _createElementVNode, withCtx as _withCtx, openBlock as _openBlock, createBlock as _createBlock } from "vue"

const _hoisted_1 = { class: "tw-p-4" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_StudioInput = _resolveComponent("StudioInput")!
  const _component_StudioDialog = _resolveComponent("StudioDialog")!

  return (_openBlock(), _createBlock(_component_StudioDialog, {
    title: `Set a new password for ${_ctx.currentUser.email}`,
    showCloseButton: false,
    primaryActionTitle: _ctx.isSubmitting ? 'Submitting...' : 'Submit',
    primaryActionDisabled: !_ctx.newPassword || !_ctx.confirmPassword || _ctx.newPassword !== _ctx.confirmPassword || _ctx.isSubmitting,
    onPrimaryAction: _ctx.newPasswordSubmit
  }, {
    default: _withCtx(() => [
      _createElementVNode("div", _hoisted_1, [
        _createVNode(_component_StudioInput, {
          id: "new-password-input",
          ref: "newPasswordRef",
          modelValue: _ctx.newPassword,
          "onUpdate:modelValue": _cache[0] || (_cache[0] = ($event: any) => ((_ctx.newPassword) = $event)),
          type: "password",
          label: "New Password",
          placeholder: "Please enter a new password",
          class: "tw-mb-4",
          required: "",
          minlength: 8,
          maxlength: 40
        }, null, 8, ["modelValue"]),
        _createVNode(_component_StudioInput, {
          id: "confirm-new-password-input",
          ref: "confirmPasswordeRef",
          modelValue: _ctx.confirmPassword,
          "onUpdate:modelValue": _cache[1] || (_cache[1] = ($event: any) => ((_ctx.confirmPassword) = $event)),
          type: "password",
          label: "Confirm Password",
          placeholder: "Please re-enter the new password",
          required: "",
          minlength: 8,
          maxlength: 40
        }, null, 8, ["modelValue"])
      ])
    ]),
    _: 1
  }, 8, ["title", "primaryActionTitle", "primaryActionDisabled", "onPrimaryAction"]))
}